// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  slot: __t.u8().primaryKey(),
  id: __t.string(),
  title: __t.string(),
  start: __t.string(),
  version: __t.string(),
  floors: __t.u16(),
  nodes: __t.u32(),
  sides: __t.u32(),
  chunks: __t.u32(),
  rows: __t.u32(),
  at: __t.timestamp(),
});
